// Gráfico de línea genérico, solo datos reales cargados — sin proyección ni estimación.
// Extraído de Progreso.js (Bloque E) para reusarlo también en DatosCompartidosPaciente.js.
export default function LineChart({ puntos, lineaReferencia, etiquetaReferencia }) {
  if (puntos.length < 2) return null
  const W = 340, H = 150
  const padL = 42, padR = 16, padT = 12, padB = 24
  const chartW = W - padL - padR
  const chartH = H - padT - padB

  const valores = puntos.map(p => p.valor).concat(lineaReferencia != null ? [lineaReferencia] : [])
  const min = Math.min(...valores) - 1
  const max = Math.max(...valores) + 1
  const rango = max - min || 1

  const inicio = new Date(puntos[0].fecha + 'T00:00:00')
  const fin = new Date(puntos[puntos.length - 1].fecha + 'T00:00:00')
  const totalDias = Math.max(1, (fin - inicio) / (1000 * 60 * 60 * 24))

  const xScale = fecha => padL + ((new Date(fecha + 'T00:00:00') - inicio) / (1000 * 60 * 60 * 24) / totalDias) * chartW
  const yScale = v => padT + (1 - (v - min) / rango) * chartH

  const path = puntos.map((p, i) => `${i === 0 ? 'M' : 'L'} ${xScale(p.fecha).toFixed(1)} ${yScale(p.valor).toFixed(1)}`).join(' ')

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block' }}>
      <line x1={padL} y1={yScale(min)} x2={W - padR} y2={yScale(min)} stroke="#E8E2D8" strokeWidth="1" />
      <text x={padL - 4} y={yScale(min) + 4} textAnchor="end" fontSize="9" fill="#999">{min.toFixed(0)}</text>
      <text x={padL - 4} y={yScale(max) + 4} textAnchor="end" fontSize="9" fill="#999">{max.toFixed(0)}</text>

      {lineaReferencia != null && (
        <>
          <line x1={padL} y1={yScale(lineaReferencia)} x2={W - padR} y2={yScale(lineaReferencia)} stroke="#C9B8D8" strokeWidth="1.5" strokeDasharray="4 3" />
          <text x={W - padR + 2} y={yScale(lineaReferencia) + 4} fontSize="9" fill="#9B88B8">{etiquetaReferencia}</text>
        </>
      )}

      <path d={path} fill="none" stroke="var(--verde)" strokeWidth="2" />
      {puntos.map((p, i) => (
        <circle key={i} cx={xScale(p.fecha)} cy={yScale(p.valor)} r={4} fill="var(--verde-dark)" stroke="white" strokeWidth="1.5" />
      ))}
    </svg>
  )
}
